export class InputAppendBuilder {
    constructor() {
        this._items = [];
        this._current = null;
        this._separated = false;
    }

    /**
     * Add a button action to the input group.
     */
    addAction(key, configOrFn) {
        const item = { type: 'button', key, text: '', icon: null, title: null, onClick: null };
        if (typeof configOrFn === 'function') {
            const wrapper = {
                withText: (t) => { item.text = t; return wrapper; },
                withIcon: (i) => { item.icon = i; return wrapper; },
                withTitle: (t) => { item.title = t; return wrapper; },
                withClass: (c) => { item.btnClass = c; return wrapper; },
                onClick: (fn) => { item.onClick = fn; return wrapper; }
            };
            configOrFn(wrapper);
        } else if (typeof configOrFn === 'object') {
            Object.assign(item, configOrFn);
        }
        this._items.push(item);
        return this;
    }

    /**
     * Shorthand: add a single button with text + icon + onClick.
     */
    withText(text) {
        if (!this._current) this._current = { type: 'button', key: 'btn_' + Math.random().toString(36).slice(2, 8), text: '', icon: null, title: null, onClick: null };
        this._current.text = text;
        return this;
    }

    withIcon(icon) {
        if (!this._current) this._current = { type: 'button', key: 'btn_' + Math.random().toString(36).slice(2, 8), text: '', icon: null, title: null, onClick: null };
        this._current.icon = icon;
        return this;
    }

    withTitle(title) {
        if (!this._current) this._current = { type: 'button', key: 'btn_' + Math.random().toString(36).slice(2, 8), text: '', icon: null, title: null, onClick: null };
        this._current.title = title;
        return this;
    }

    onClick(fn) {
        if (!this._current) this._current = { type: 'button', key: 'btn_' + Math.random().toString(36).slice(2, 8), text: '', icon: null, title: null, onClick: null };
        this._current.onClick = fn;
        return this;
    }

    withClass(btnClass) {
        if (!this._current) this._current = { type: 'button', key: 'btn_' + Math.random().toString(36).slice(2, 8), text: '', icon: null, title: null, onClick: null };
        this._current.btnClass = btnClass;
        return this;
    }

    /**
     * Add a checkbox item to the input group.
     */
    addCheckbox(id, label, optionsOrFn = {}) {
        if (this._current) {
            this._items.push(this._current);
            this._current = null;
        }
        const item = { type: 'checkbox', id, label, value: '1', checked: false };
        if (typeof optionsOrFn === 'function') {
            const wrapper = {
                withColor: (c) => { item.color = c; return wrapper; },
                withLabelColor: (c) => { item.labelColor = c; return wrapper; },
                withValue: (v) => { item.value = v; return wrapper; },
                checked: (val = true) => { item.checked = val; return wrapper; }
            };
            optionsOrFn(wrapper);
        } else if (typeof optionsOrFn === 'object') {
            Object.assign(item, optionsOrFn);
        }
        this._items.push(item);
        return this;
    }

    /**
     * Add a static icon tag item to the input group.
     */
    addIcon(icon, text = '') {
        if (this._current) {
            this._items.push(this._current);
            this._current = null;
        }
        this._items.push({ type: 'tag', icon, text });
        return this;
    }

    /**
     * Add a static tag item to the input group.
     */
    addTag(text, icon = null) {
        if (this._current) {
            this._items.push(this._current);
            this._current = null;
        }
        this._items.push({ type: 'tag', text, icon });
        return this;
    }

    /**
     * Mark the current item as a non-interactive tag (e.g. prefix label).
     */
    asTag() {
        if (this._current) this._current.type = 'tag';
        return this;
    }

    /**
     * Use separated layout (gap between input and button) instead of
     * the default attached layout (flush .input-group).
     * This applies to the entire input group, not just the current item.
     */
    separated() {
        this._separated = true;
        return this;
    }

    /**
     * Finalize and return the items array.
     */
    _build() {
        if (this._current) {
            this._items.push(this._current);
            this._current = null;
        }
        return this._items;
    }
}
